import styled from "@emotion/styled";
import { fontRoboto, transientOptions } from "@product/scmp-sdk";

import { BaseLink } from "~/components/common/base-link";

type StyledBaseLinkProps = {
  $isSelected: boolean;
};

export const StyledBaseLink = styled(BaseLink, { ...transientOptions })<StyledBaseLinkProps>`
  color: #001246;
  font-weight: ${props => (props.$isSelected ? 700 : 400)};
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;
`;

export const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;

  block-size: 60px;

  white-space: nowrap;

  background-color: #ffffff;

  overflow-x: auto;
  /* Hide the scrollbar */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }

  ${StyledBaseLink}:not(:last-child):after {
    content: "•";

    padding-inline: 12px;
  }
  ${StyledBaseLink}.last:after {
    content: "";
  }
`;
